module.exports = __webpack_public_path__ + "static/img/content-img-4.d77697ba.jpg";